import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'

import { PhoneInput } from '../../atoms/PhoneInput/PhoneInput'
import { RevalidateCard } from '../../organisms/RevalidateCard'
import { isValid as isValidPhone, removeMask as removePhoneMask } from '../../../util/PhonePattern'

import { formatedTime } from '../../../util/date'

export const PhoneRevalidationTemplate = ({
  shouldDisableSendButton,
  onBack,
  onClickFooterButton,
  onSubmit,
  clearErrors,
  error,
  alreadyHasPhone,
  inputControl,
  isLocked,
  isSubmitting,
  lockTime,
}) => {
  const buttonDescription = isLocked
    ? `Enviar código em ${formatedTime(lockTime)}`
    : 'Enviar código para esse telefone'
  const disableSendButton = shouldDisableSendButton || isLocked

  return (
    <RevalidateCard
      title="Verificação de telefone"
      description="Um código será enviado por SMS para o seu celular. Se fixo, faremos uma ligação."
      alertDescription="O mesmo número de telefone não pode ser usado em mais de uma conta OLX."
      buttonDescription={buttonDescription}
      footerDescription="Não tem mais acesso a esse telefone?"
      caption={{
        description: 'Não tem mais acesso a esse telefone?',
        buttonDescription: 'Clique aqui',
      }}
      callBackCaptionButton={onClickFooterButton}
      error={error}
      disableSendButton={disableSendButton}
      isLoading={isSubmitting}
      showFooter={alreadyHasPhone}
      onBack={onBack}
      onSend={onSubmit}
      onClickFooterButton={onClickFooterButton}
    >
      <Controller
        name="phone"
        control={inputControl}
        rules={{
          validate: phone => alreadyHasPhone || isValidPhone(removePhoneMask(phone)),
        }}
        render={({ field, fieldState }) => (
          <PhoneInput
            {...field}
            {...fieldState}
            clearErrors={clearErrors}
            disabled={alreadyHasPhone}
          />
        )}
      />
    </RevalidateCard>
  )
}

PhoneRevalidationTemplate.propTypes = {
  shouldDisableSendButton: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool,
  onBack: PropTypes.func,
  onClickFooterButton: PropTypes.func,
  onPhoneVerifyClick: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  error: PropTypes.object,
  alreadyHasPhone: PropTypes.bool,
  inputControl: PropTypes.object,
  isLocked: PropTypes.bool,
  lockTime: PropTypes.number,
}
